export default __webpack_public_path__ + "static/media/staking-bg-table-mobile.99ddf2ce.png";